import { IApplicationState } from '../../types/redux';

/**
 * Выбирает опрос для поста
 */
export const selectPostPoll = ({ postPoll }: IApplicationState) => postPoll;
